import 'apps/hiring/styles/components/add-behavior-modal.scss';
import React from 'react';

export default class AddAttributeModal extends React.Component {
  state = {
    adding: false
  }

  mapCharacteristics = ({ id, name }) => (
    <div className="edit-target-attribute" key={id}>
      <span className="edit-target-attribute-name">{ name }</span>
      <span className="flex-spacer" />
      <button className="button-noborder-tertiary" onClick={()=>!this.state.adding&&this.handleAdd({id,name})} disabled={this.state.adding}>ADD</button>
    </div>
  )

  handleAdd = async (val) => {
    this.setState({
      adding: true
    })
    await this.props.add(val);
    this.setState({
      adding: false
    })
  }

  render() {
    const {
      characteristics,
      exclude=[],
    } = this.props;

    return (
      <div className="hiring-modal">
        <div className="hiring-modal-header">
          <div className="hiring-modal-header-inner">
            <p>Choose an Attribute</p>
            <a onClick={this.props.onClose} href="javascript:void(0)">×</a>
          </div>
          <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
            <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
            <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
          </svg>
        </div>
        <div className="hiring-modal-body">
          { characteristics.filter(c=>!exclude.includes(c.id)).map(this.mapCharacteristics) }
        </div>
        <div className="hiring-modal-footer">
        </div>
      </div>
    );
  }
}
